<template>
    <div>
        
        <a-row :gutter="16" style="margin-bottom: 50px;">
            <a-col :sm="{ span: 24, offset: 0 }" :xs="{ span: 24, offset: 0 }" :lg="{ span: 12, offset: 6 }">
                <a-card class="mt-50 mb-50">
                    
                    <img style="width: 100%; height: 10vh;" slot="cover" alt="imag_main_1" src="./banner.png" />
                    <template slot="title">
                        <div class="text-center">
                            <h5 style="color: #000000;" class="font-web mt-0 mb-0 font-weight-bold">Welcome to the New
                                Term – Your IT Services and Support
                                Guide</h5>
                        </div>
                    </template>
                    <!-- FullTime and PartTime -->
                    <div class="mt-10 mb-10">
                        <h6 class="font-web mt-0 mb-20 ml-10 font-weight-bold text-dark">
                            {{ getTokenUrl === 'PartTime' ? `As the new term begins, here’s a quick overview of key IT services available to support your teaching at MUIC.` : getTokenUrl === 'FullTime' ? `As the new term starts, we would like to remind you of the key IT services and resources available to support your work at MUIC. Please find a quick overview below:` : `Get ready for an awesome new
                            term! The IT
                            department is here
                            to support you with a range of IT tools and services. Here’s an overview.` }}</h6>
                        <a-list item-layout="horizontal" :data-source="getTokenUrl === 'PartTime' ? dataLecturePT : getTokenUrl === 'FullTime' ? dataLectureFT : data">
                            <a-list-item slot="renderItem" slot-scope="item, index">
                                <a-list-item-meta>
                                    <div slot="title">
                                        <h5 class="font-web mt-5 mb-10 font-weight-bold">{{ item.title }}</h5>
                                        <span v-if="!['',null].includes(item.detail)" class="font-web mt-10 mb-0 font-weight-bold" v-html="item.detail"></span>
                                    </div>
                                    <a-avatar :style="{ backgroundColor: `${item.color}`, verticalAlign: 'middle' }" slot="avatar" shape="square" :size="50" :icon="item.icon" />
                                    <div slot="description">
                                        <a-list v-if="item.htmltag.length != 0" item-layout="horizontal" :data-source="item.htmltag">
                                            <a-list-item slot="renderItem" slot-scope="item, index">
                                                <a-list-item-meta>
                                                    <h6 slot="title" class="font-web mt-5 mb-0 font-weight-bold"><a-icon
                                                            class="mr-2" type="caret-right" /> {{ item.label
                                                        }}</h6>
                                                    <div class="font-web ml-20" slot="description">
                                                        <span class="text-dark" v-html="item.htmltag"></span>
                                                    </div>
                                                </a-list-item-meta>
                                            </a-list-item>
                                        </a-list>
                                    </div>
                                </a-list-item-meta>
                            </a-list-item>
                        </a-list>
                        <div class="text-center">
                            <span style="font-size: 14px;" class="text-muted font-web mt-20 mb-30 ml-10">
                                <i><br>{{ getTokenUrl === 'PartTime' ? `For any assistance, feel free to contact IT. We’re here to help!` : getTokenUrl === 'FullTime' ? `If you need any assistance or encounter any technical issues, please reach out to our Tech Support Team via LINE @myMUIC or call Ext. 4555. We're here to help!` : ` For assistance, reach out to our IT Help Desk. We're here to help!` }}
                                    <br>( Update 14 / 09 / 2024 )</i>
                            </span>
                        </div>
                    </div>

                    <!-- FOOTER -->
                    <template slot="actions" class="ant-card-actions">
                        <div key="setting" @click="gotoFormRequest('https://newmy.muic.io/dashboard')">
                            <a-avatar
                                class="mt-5"
                                shape="square"
                                size="large"
                                :style="{ fontSize: '20px', backgroundColor: color, verticalAlign: 'middle' }"
                            >
                                <a-icon type="home" />
                            </a-avatar>
                            <br>
                            <span class="font-web text-primary" style="font-size: 18px;">IC - PORTAL</span>
                        </div>
                        <div key="edit" @click="gotoFormRequest(['PartTime','FullTime'].includes(`${getTokenUrl}`) ? 'https://instructor.muic.io/':'https://sky-training.muic.io/')">
                            <img style="width: 45px; height: 45px;" slot="cover" alt="imag_main_2" src="./logoSky.png" />
                            <br>
                            <span class="font-web text-primary" style="font-size: 16px;">{{ ['PartTime','FullTime'].includes(`${getTokenUrl}`) ? `SKY+ Instructor Sit` : `SKY+ Tutorial` }}</span>
                        </div>
                        <div key="ellipsis" @click="gotoFormRequest('https://os.muic.io/')" >
                            <a-avatar
                                class="mt-5"
                                shape="square"
                                size="large"
                                :style="{ fontSize: '20px', backgroundColor: color, verticalAlign: 'middle' }"
                            >
                                <a-icon type="calendar" />
                            </a-avatar>
                            <br>
                            <span class="font-web text-primary" style="font-size: 18px;">os.muic.io</span>
                        </div>
                    </template>
                </a-card>
            </a-col>
        </a-row>

    </div>
</template>

<script>
const data = [
    {
        title: 'Key IT Services',
        detail: '',
        icon: 'pushpin',
        color: '#78B7D0',
        htmltag: [
            {
                label: 'Help Desk Support:',
                htmltag: 'Contact us at <a href="mailto:icit@mahidol.ac.th" target="_blank"><u>icit@mahidol.ac.th</u></a>, call  02-700-5000 ext.1555, 4200,  or via the Student <a href="https://newmy.muic.io/dashboard" target="_blank"><u>Web Portal</u></a>. Support hours: Mon-Fri, 8am - 5pm.</span>',
            },
            {
                label: 'Wi-Fi Access:',
                htmltag: 'Connect to @MUIC-WiFi using SKY+ credentials or MU-WiFi using your Mahidol email. <a href="https://drive.google.com/drive/folders/1Va93fLV5MaGCEHi-UC0EV07kOSs4jp6u" target="_blank"><u>Setup guide here</u></a>.',
            },
            {
                label: 'Email & LMS:',
                htmltag: `
                    Access your <a href="https://login.microsoftonline.com/"
                                                            target="_blank"><u>Microsoft 365 inbox</u></a> inbox
                                                        and <a href="https://gmail.com/" target="_blank"><u>Google
                                                                inbox</u></a> <a href="https://drive.google.com/file/d/1qg6WB_yGUGIJ_ONW4c7PTdx-xpF6-BJQ/view"
                                                        target="_blank"><u>Configure it on your devices</u></a>. Log
                                                        into <a href="https://muicelearning.mahidol.ac.th/"
                                                            target="_blank"><u>MUIC E-Learning</u></a>.  Need help? <a
                                                        href="https://muic.mahidol.ac.th/eng/academic-resources/keep-teaching-learning/keep-learning/online-learning-resources/"
                                                        target="_blank"><u>Check out this guide</u></a>
                `,
            },
            {
                label: 'Open Section:',
                htmltag: `
                <a
                    href="https://os.muic.io" target="_blank"><u>View
                        courses</u></a> for the current term.
                `,
            }
        ],
    },
    {
        title: 'Software & Tools',
        detail: '',
        icon: 'code-sandbox',
        color: '#78B7D0',
        htmltag: [
            {
                label: 'Adobe Creative Cloud and other software:',
                htmltag: `Available for free. <a href="https://softwaredownload.mahidol.ac.th/"
                                                            target="_blank"><u>Learn more</u></a>.`,
            },
            {
                label: 'Microsoft Office 365:',
                htmltag: `<a
                                                            href="https://login.microsoftonline.com"
                                                            target="_blank"><u>Log in</u></a> using your Mahidol
                                                        email credentials.`,
            },
            {
                label: 'Remote Learning Tools:',
                htmltag: `Use
                                                        Zoom, Microsoft Teams, and Google Meet.  <a
                                                            href="https://muic.mahidol.ac.th/eng/academic-resources/keep-teaching-learning/keep-learning/online-learning-resources/"
                                                            target="_blank"><u>Learn more</u></a>.`,
            }
        ]
    },
    {
        title: 'Printing Services',
        detail: '',
        icon: 'printer',
        color: '#78B7D0',
        htmltag: [
            {
                label: 'Print at self-service stations:',
                htmltag: `in the co-working
                space and computer labs. <a
                    href="https://drive.google.com/file/d/1S_LCLx9qzN5P89QBMi-rm8kvNLFbVzHd/view"
                    target="_blank"><u>Learn more</u></a>.`,
            },
        ]
    },
    {
        title: 'Security & Privacy',
        detail: '',
        color: '#78B7D0',
        icon: 'lock',
        htmltag: [
            {
                label: 'Forgot password ?',
                htmltag: `Reset
                your <a href="https://iforgot.muic.mahidol.ac.th/"
                    target="_blank"><u>MUIC account password</u></a> or <a
                    href="https://myinternet.mahidol.ac.th/forgotpassword"
                    target="_blank"><u>MU account password</u></a>.`,
            },
            {
                label: 'Phishing Awareness:',
                htmltag: `Stay
                safe from phishing attacks
                <a href="https://www.kaspersky.com/resource-center/preemptive-safety/phishing-prevention-tips"
                    target="_blank"><u>Learn more</u></a>.`,
            },
        ]
    },
    {
        title: 'Additional Resources',
        detail: '',
        icon: 'book',
        color: '#78B7D0',
        htmltag: [
            {
                label: 'Library Access:',
                htmltag: `<a
                                                            href="https://lib.muic.mahidol.ac.th/e-resources/"
                                                            target="_blank"><u>Use online resources</u></a>.`,
            },
            {
                label: 'SKY+:',
                htmltag: `Manage your courses
                                                        and profile. <a href="https://sky-training.muic.io/"
                                                            target="_blank"><u>Find the tutorials here</u></a>.`,
            }
        ]
    },
];

const dataLectureFT = [
    {
        title: 'Wi-Fi Access',
        detail: `You can connect to the @MUIC-WiFi network using your SKY+ credentials. <a href="https://drive.google.com/drive/folders/1fsnDHpqqoNEtBJa8i6PaABbasa9MOB-F?usp=sharing" target="_blank" rel="noopener noreferrer">Click here</a> for configuration details.`,
        icon: 'printer',
        color: '#78B7D0',
        htmltag: []
    },
    {
        title: 'SKY+ Mobile App',
        detail: `The SKY+ mobile app allows you to view your advisees’ records, teaching schedules, attendance, and more. Download the app for <a href="https://apps.apple.com/th/app/muic-sky-for-lecturer/id1547635444" target="_blank" rel="noopener noreferrer">iOS</a> and <a href="https://play.google.com/store/apps/details?id=whiz.muic.uspark.pro.android&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">Android</a> and stay connected on the go.`,
        icon: 'mobile',
        color: '#78B7D0',
        htmltag: []
    },
    {
        title: 'MUIC Web Portal',
        detail: `The <a href="https//my.muic.io" target="_blank" rel="noopener noreferrer">MUIC Web Portal</a> centralizes all the important resources for your work, including the <a href="https://instructor.muic.io/" target="_blank" rel="noopener noreferrer">SKY+ Instructor Site</a>, college announcements, the MUIC directory, and more. Access it with your SKY+ credentials.`,
        icon: 'desktop',
        color: '#78B7D0',
        htmltag: []
    },
    {
        title: 'Multifunction Printing Services',
        detail: `Use your ID card to photocopy, scan, and print at any multifunction printing station around campus. For setup instructions, <a href="https://drive.google.com/file/d/1btGsDxuZbZsJIascXe8a2Biidx-xoeiC/view?usp=drive_link" target="_blank" rel="noopener noreferrer">click here</a>.`,
        icon: 'printer',
        color: '#78B7D0',
        htmltag: []
    },
    {
        title: 'Password Reset',
        detail: `Forgot your SKY+ password? No problem! <a href="https://iforgot.muic.mahidol.ac.th/" target="_blank" rel="noopener noreferrer">Follow these instructions</a> to reset it.`,
        icon: 'lock',
        color: '#78B7D0',
        htmltag: []
    },
    {
        title: 'Software Access',
        detail: `You can download software provided by Mahidol University through the <a href="https://softwaredownload.mahidol.ac.th/" target="_blank" rel="noopener noreferrer">MU Software Download Center</a> using your MU credentials. Working from home? <a href="https://muit.mahidol.ac.th/vpn.htm" target="_blank" rel="noopener noreferrer">Configure VPN</a> to access the MU network.`,
        icon: 'block',
        color: '#78B7D0',
        htmltag: []
    },
    {
        title: 'Microsoft Copilot',
        detail: `Access <a href="https://copilot.microsoft.com/" target="_blank" rel="noopener noreferrer">Microsoft Copilot</a> generative AI by signing in using MU credentials to enhance productivity in your daily tasks.`,
        icon: 'robot',
        color: '#78B7D0',
        htmltag: []
    },
]

const dataLecturePT = [
    {
        title: 'Printing Services',
        detail: `Multifunction printers are available in <a href="https://drive.google.com/file/d/1Cxw6rheWHBgqGjT3pnD0AvZwWHvWElV2/view" target="_blank" rel="noopener noreferrer">both buildings</a>. To set up printing, email IT to schedule a setup, or <a href="https://drive.google.com/file/d/1btGsDxuZbZsJIascXe8a2Biidx-xoeiC/view?usp=sharing" target="_blank" rel="noopener noreferrer">click here for instructions</a>. You have a 100-page black-and-white quota per term.`,
        icon: 'printer',
        color: '#78B7D0',
        htmltag: []
    },
    {
        title: 'MUIC Web Portal',
        detail: `Access the <a href="http://my.muic.io" target="_blank" rel="noopener noreferrer">MUIC Web Portal</a> with your SKY+ credentials for teaching records, college announcements, and other essential resources.`,
        icon: 'desktop',
        color: '#78B7D0',
        htmltag: []
    },
    {
        title: 'Password Reset',
        detail: `Forgot your password? Follow <a href="https://iforgot.muic.mahidol.ac.th" target="_blank" rel="noopener noreferrer">this guide</a> to reset it or contact IT staff for help.`,
        icon: 'lock',
        color: '#78B7D0',
        htmltag: []
    },
    {
        title: 'Wi-Fi Access',
        detail: `Connect to @MUIC-WiFi using your SKY+ credentials. <a href="https://drive.google.com/drive/folders/1fsnDHpqqoNEtBJa8i6PaABbasa9MOB-F?usp=sharing" target="_blank" rel="noopener noreferrer">Learn how to set it up here</a>.`,
        icon: 'wifi',
        color: '#78B7D0',
        htmltag: []
    },      
];

export default {
    name: "main",
    data() {
        return {
            data,
            dataLecturePT,
            dataLectureFT
        }
    },
    computed: {
        getTokenUrl() {
            return this.$route.query.type === undefined || this.$route.query.token === "" ? 'std' : this.$route.query.type
        },
    },
    methods: {
        gotoFormRequest(pathUrl) {
            globalThis.open(`${pathUrl}`);
        },
    }
};
</script>

<style scoped>
.logo-size {
  width: 200px;
  height: 70px;
  margin-top: 25px;
  z-index: -999;
}
</style>